import { useNavigate } from "react-router-dom";
import { Button, Grid } from "antd-mobile";
import bannerImg from "../assets/banner.png";
import by from "../assets/by.png";
import jy from "../assets/jy.png";
import ts from "../assets/ts.png";
import zx from "../assets/zx.png";
import code from "../assets/code.jpg";
import more from "../assets/more.png";
import search from "../assets/search.png";

export default function HomePage() {
  const navigate = useNavigate();

  const serviceTypes = [
    {
      title: "投诉类",
      color: "#ff4d4f",
      img: ts,
      key: "TS",
      id: "1895755815348998144",
    },
    {
      title: "咨询类",
      color: "#1890ff",
      img: zx,
      key: "ZX",
      id: "1895755783115771904",
    },
    {
      title: "建议类",
      color: "#52c41a",
      img: jy,
      key: "JY",
      id: "1895755850606317568",
    },
    {
      title: "表扬类",
      color: "#faad14",
      img: by,
      key: "BY",
      id: "1898520861397356544",
    },
  ];

  return (
    <div
      style={{
        height: "100%",
        minHeight: "100vh",
        backgroundColor: "#ECF2F7",
        overflowY: "auto",
        padding: "0 0 16px 0",
      }}
    >
      <div style={{ position: "relative" }}>
        <img src={bannerImg} alt="banner" style={{ width: "100%" }} />
      </div>
      <div
        style={{
          margin: "0 16px",
          padding: 12,
          marginTop: -80,
          backgroundColor: "white",
          borderRadius: 10,
          zIndex: 99,
          position: "relative",
        }}
      >
        <div style={{ color: "#333333", fontSize: 17, fontWeight: 800 }}>
          请选择您的诉求分类:
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {serviceTypes.map((type, index) => (
            <div
              className="service-type"
              key={index}
              style={{
                width: "48%",
                height: 70,
                borderRadius: 8,
                backgroundImage: `url(${type.img})`,
                backgroundSize: "100% 100%",
                backgroundPosition: "center",
                marginTop: 12,
              }}
              onClick={() =>
                navigate(
                  `/submit?id=${type.id}&title=${type.title.slice(0, 2)}`
                )
              }
            >
              <div
                style={{
                  color: "#333",
                  fontWeight: "bold",
                  height: 70,
                  lineHeight: "70px",
                  fontSize: 18,
                  paddingLeft: 16,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span>{type.title}</span>
                <img style={{ width: 16, marginLeft: 6 }} src={more} alt="" />
              </div>
            </div>
          ))}
        </div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 12,
            fontSize: 14,
            borderRadius: 8,
            border: "1px solid #3769F4",
            color: "#3769F4",
            marginTop: 14,
          }}
          onClick={() => navigate("/query")}
        >
          <span>投诉工单处理结果查询</span>
          <img style={{ width: 24, marginLeft: 6 }} src={search} alt="" />
        </div> */}
        <div className="jd">
          <div className="tm">投诉工单处理结果查询</div>
          <div className="category">
            {serviceTypes.map((item) => {
              return <section key={item.id} onClick={() => navigate("/query?typeCode="+item.key)}>{item.title}</section>;
            })}
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          padding: 16,
          margin: "0 16px",
          marginTop: 12,
          borderRadius: 8,
        }}
      >
        <h3 style={{ color: "#333" }}>简介</h3>
        <p
          style={{
            margin: 0,
            color: "#666",
            fontSize: 15,
            lineHeight: "26px",
            marginTop: 8,
            paddingBottom: 12,
          }}
        >
          湾里管理局为进一步深化政务服务改革，精准、快速、高效解决群众急难愁盼问题，全面提升群众满意度、获得感。通过成立一个机构、打造一个平台、开通一条热线、织好一张网格，构建一套"一扫即办、一呼即应"的"湾里办"新经验、新模式、新品牌。
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: 16,
            borderTop: "1px solid #dedede",
            lineHeight: "26px",
          }}
        >
          <div style={{ fontSize: 15 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>参与方式1: </div>
            <div style={{ marginBottom: 6 }}>
              服务热线：
              <span style={{ color: "#3769F4" }}>0791-87123456</span>
            </div>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>参与方式2: </div>
            <div>微信扫描二维码进入“湾里办”服务平台</div>
          </div>
          <img style={{ width: 150, height: 150 }} src={code} alt="" />
        </div>
      </div>
    </div>
  );
}
